import { ResendSignUpCodeInput, resendSignUpCode } from 'aws-amplify/auth';

export const attemptResendSignUp = async ({ username }: ResendSignUpCodeInput) => resendSignUpCode({ username });

interface AuthResendSignUpProps {
  email: string;
}

const authResendSignUp = async ({ email }: AuthResendSignUpProps) => {
  try {
    const result = await attemptResendSignUp({ username: email });

    return { success: true, email: result.destination };
  } catch (e) {
    if (!(e instanceof Error)) {
      // TODO: Log to rollbar
      return { success: false, reason: 'Unknown error' };
    }

    return { success: false, reason: e.message };
  }
};

export default authResendSignUp;
